const isPdfFileUrl = (url?: string) => !!url && /\.pdf$/i.test(url);

export default isPdfFileUrl;
